import { cn } from '@/utils';
import * as React from 'react';

const Table = React.forwardRef(({ className, ...props }, ref) => (
    <div className="tw-relative tw-w-full tw-overflow-auto">
        <table
            className={cn('tw-w-full tw-caption-bottom tw-text-sm', className)}
            ref={ref}
            {...props}/>
    </div>
));
Table.displayName = 'Table';

const TableHeader = React.forwardRef(({ className, ...props }, ref) => (
    <thead className={cn('[&_tr]:tw-border-b-0 tw-border-b tw-border-solid tw-border-border', className)} ref={ref} {...props}/>
));
TableHeader.displayName = 'TableHeader';

const TableBody = React.forwardRef(({ className, ...props }, ref) => (
    <tbody
        className={cn('[&_tr:last-child]:tw-border-b [&_tr:last-child]:tw-border-solid [&_tr:last-child]:tw-border-border', className)}
        ref={ref}
        {...props}/>
));
TableBody.displayName = 'TableBody';

const TableFooterShad = React.forwardRef(({ className, ...props }, ref) => (
    <tfoot
        className={cn(
            'tw-border-t tw-bg-muted/50 tw-font-medium [&>tr]:last:tw-border-b-0',
            className
        )}
        ref={ref}
        {...props}/>
));
TableFooterShad.displayName = 'TableFooter';

const TableRow = React.forwardRef(({ className, ...props }, ref) => (
    <tr
        className={cn(
            'even:tw-bg-grey-bg tw-border-b tw-transition-colors hover:tw-bg-muted/50 data-[state=selected]:tw-bg-muted',
            className
        )}
        ref={ref}
        {...props}/>
));
TableRow.displayName = 'TableRow';

const TableHead = React.forwardRef(({ className, ...props }, ref) => (
    <th
        className={cn(
            'tw-h-12 tw-px-4 tw-text-left tw-align-middle tw-font-medium tw-text-muted-foreground [&:has([role=checkbox])]:tw-pr-0 !tw-border-0',
            className
        )}
        ref={ref}
        {...props}/>
));
TableHead.displayName = 'TableHead';

const TableCell = React.forwardRef(({ className, ...props }, ref) => (
    <td
        className={cn('tw-p-4 tw-align-middle [&:has([role=checkbox])]:tw-pr-0 tw-border-none', className)}
        ref={ref}
        {...props}/>
));
TableCell.displayName = 'TableCell';

const TableCaption = React.forwardRef(({ className, ...props }, ref) => (
    <caption
        className={cn('tw-mt-4 tw-text-sm tw-text-muted-foreground', className)}
        ref={ref}
        {...props}/>
));
TableCaption.displayName = 'TableCaption';

export {
    Table,
    TableHeader,
    TableBody,
    TableFooterShad,
    TableHead,
    TableRow,
    TableCell,
    TableCaption
};
